import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgCartHeader = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.502 2.25a.75.75 0 0 1 .75.607L7.273 13.25h10.775a.25.25 0 0 0 .242-.187l1.484-5.75a.75.75 0 1 1 1.452.374l-1.484 5.75a1.75 1.75 0 0 1-1.694 1.313H7.565l.292 1.505q.08-.005.16-.005c1.258 0 2.32.846 2.646 2h3.707a2.751 2.751 0 0 1 5.396.75 2.75 2.75 0 0 1-5.396.75h-3.707a2.751 2.751 0 1 1-4.236-2.994L3.897 3.75H1.5a.75.75 0 0 1 0-1.5h3.002m3.514 15.5q-.252.002-.468.09a1.25 1.25 0 1 0 .468-.09m9 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgCartHeader;
